import React, { Component } from "react";
import { Button, PageHeader, MenuItem, Modal, Row, Col } from "react-bootstrap";
import ReactPhoneInput            from "react-phone-input-2";
import ReactPlayer                from 'react-player'
import config                     from "../../config";
import KeywordsInput              from "../../components/exercise/KeywordsInput";
import LoaderButton               from "../../components/LoaderButton";
import RenderLander               from "../../components/utils/RenderLander";
import FooterLoadingBar           from "../../components/utils/FooterLoadingBar";
import AutoSuggestClientName      from "../../components/autosuggest/AutoSuggestClientName";
import BodyCompForm               from "../../components/assessment/BodyCompForm";
import GirthForm                  from "../../components/assessment/GirthForm";
import InBodyForm                 from "../../components/assessment/InBodyForm";
import FMSForm                    from "../../components/assessment/FMSForm";
import PARQForm                   from "../../components/assessment/PARQForm";
import HeartAndBloodForm          from "../../components/assessment/HeartAndBloodForm";
import LowerBodyPowerForm         from "../../components/assessment/LowerBodyPowerForm";
import PrimalMovement             from "../../components/assessment/PrimalMovementForm";
import StrengthForm               from "../../components/assessment/StrengthForm";
import JointROMForm               from "../../components/assessment/JointROMForm";
import SpinalROMForm              from "../../components/assessment/SpinalROMForm";
import { handleGoToURL}           from "../../utils/URL";
import AssessmentEditor           from "../../components/assessment/AssessmentEditor";
import { API, Storage }           from "aws-amplify";
import { convertToRaw }           from 'draft-js';
import ModalAlert                 from "../../components/modal/ModalAlert";
import { Colors }                 from "../../utils/Colors";
import { convertImageAttributes,
         compareExistingToNewImages } from "../../screens/assessment/utils";
import "../../css/assessment/AssessmentNew.css";

import { invokeSetAddAssessment,
         invokeGetAssessmentDetail,
         invokeSetAddInBodyAssessment } from "../../utils/AwsInvoke";

const CHAR_COUNT = 1500;
const rawState = {"blocks":[{"key":"637gr","text":"Kevin Lu: 😎","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"87vpl","text":"Claire Wyttynck 😍","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}};
const emptyTemplate = {"blocks":[{"key":"6t07u","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"dsmoh","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"7kb5d","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"3d1uk","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}};

const questionnaireBasicTemplate = {"blocks":[{"key":"6t07u","text":"1. What’s your full name?","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":25,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"2nvbq","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"63qjj","text":"2. What’s your email address?","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":29,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"32sd1","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"cfiir","text":"3. What’s your phone number?","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":28,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"9toh5","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"bi5a0","text":"4. What’s your biological sex?","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":30,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"b7873","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"3akrl","text":"5. What’s your birth date? ","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":27,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"dsmoh","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"3d1uk","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}};

export default class AssessmentNew extends Component {
    constructor(props) {
        super(props);

        //this.file = `${this.props.match.params.document_id}`;

        this.state = {
          isLoading: false,
          companyId: "",
          clientName: "",
          clientNameSearch: "",
          clientId:   `${this.props.match.params.client_id}`,
          uid:        `${this.props.match.params.document_id}`,
          assessType: `${this.props.match.params.assessment_type}`,
          existingEditorImages: [],
          //newEditorImages: [],
          loadingData: "",
          showLoadingBar: "none",
          pageOverlay: "none",
          showConfirmWin: false,
          pageTitle: "",
          raw_content: rawState,
          imageURL: "",
          inputValue: "",
          title: "", // set default title of tf so it remains "controlled"

          // InBody Assessment
          totalBodyWater: "",
          dryLeanMass: "",
          bodyFatMass: "",
          pbf: "",
          smm: "",
          bmi: "",
          weight: "",

          rightArm: "",
          leftArm: "",
          trunk: "",
          rightLeg: "",
          leftLeg: "",

          modalAlertTitleText: "",
          modalAlertBodyText:  "",
          showModalAlert:      false, // true | false
          alertObject:         {},
          alertAction:         "",
        };
    }

    componentDidMount() {
        if (!this.props.isAuthenticated) {
            return;
        }

        try {
            var client_id = this.state.clientId;
            var uid       = this.state.uid;
            var action    = "";

            if(uid === "undefined")
                action = "new";

            if(uid === "undefined" && client_id === "&") {
                // add other "new" assessment code
            } else {
                this.getAssessmentData(action, client_id, uid);
            }

        } catch (e) {
            alert(e);
        }
    }

    msgDataLoaded = () => {
        this.setState({
            loadingData: ""
        })
    }

    getAssessmentData = async (action, client_id, uid) => {
        var page_title = "Assessment Profile";

        if(action === "new")
            page_title = "Add New Assessment";

            this.setState({
                pageTitle: page_title,
                loadingData: "Loading assessment data ... "
            })
            var screen = "getGeneralAssessment"; // don't change this screen
            const results = await invokeGetAssessmentDetail(screen, action, client_id, uid);

            if(results) {
                var data;
                var member_name;
                var title;
                var pre_title;
                var assessment_id;
                var content;
                var date;
                var curr_assess_type = this.state.assessType;

                // Inbody vars
                var assess_type = 1; //"inbody"
                var data_inbody;
                var total_body_water;
                var dry_lean_mass;
                var body_fat_mass;
                var pbf;
                var smm;
                var bmi;
                var weight;
                var right_arm;
                var left_arm;
                var trunk;
                var right_leg;
                var left_leg;
                // Only Use InBody data if the form is InBody

                if(results.data != undefined) {
                        data           = results.data.client_data[0];
                        member_name    = data.first_name + " " + data.last_name;
                        title          = data.title;
                        assessment_id  = data.assessment_id;
                        content        = data.content;
                        date           = data.date_created;
                        assess_type    = data.assessment_type; //"inbody"
                }
                //console.log("assess_type: " + assess_type);

                if(assess_type == 2 || curr_assess_type == "inbody") {

                    ////  Check if the screen is a new form or not  ////
                    if(results.data.other_assess_data != undefined) {
                        data_inbody      = results.data.other_assess_data[0];
                        total_body_water = data_inbody.total_body_water;
                        dry_lean_mass    = data_inbody.dry_lean_mass;
                        body_fat_mass    = data_inbody.body_fat_mass;
                        pbf              = data_inbody.pbf;
                        smm              = data_inbody.smm;
                        bmi              = data_inbody.bmi;
                        weight           = data_inbody.weight;

                        right_arm        = data_inbody.right_arm;
                        left_arm         = data_inbody.left_arm;
                        trunk            = data_inbody.trunk;
                        right_leg        = data_inbody.right_leg;
                        left_leg         = data_inbody.left_leg;
                    }

                    assess_type     = "inbody";
                    pre_title       = "InBody";
                } else if (assess_type == 4 || curr_assess_type == "heartandblood") {
                    pre_title       = "Heart & Blood Check";
                    assess_type     = "heartandblood";
                } else if (assess_type == 3 || curr_assess_type == "fms") {
                    pre_title       = "Functional Movement";
                    assess_type     = "fms";
                } else if (assess_type == 5 || curr_assess_type == "lowerbodypower") {
                    pre_title       = "Lower Body Power";
                    assess_type     = "lowerbodypower";
                } else if (assess_type == 6 || curr_assess_type == "parq") {
                    pre_title       = "PAR-Q";
                    assess_type     = "parq";
                } else if (assess_type == 7 || curr_assess_type == "primalmovement") {
                    pre_title       = "Primal Movement Patterns";
                    assess_type     = "primalmovement";
                } else if (assess_type == 8 || curr_assess_type == "strength") {
                    pre_title       = "Strength";
                    assess_type     = "strength";
                } else if (assess_type == 9 || curr_assess_type == "jointrom") {
                    pre_title       = "Joint ROM";
                    assess_type     = "jointrom";
                } else if (assess_type == 10 || curr_assess_type == "spinalrom") {
                    pre_title       = "Spinal ROM";
                    assess_type     = "spinalrom";
                } else if (assess_type == 11 || curr_assess_type == "bodycomp") {
                    pre_title       = "Body Composition";
                    assess_type     = "bodycomp";
                } else if (assess_type == 12 || curr_assess_type == "girth") {
                    pre_title       = "Girth Measurements";
                    assess_type     = "girth";
                }

                this.setState({
                    clientName: member_name,
                    title: title,
                    preTitle: pre_title,
                    assessType: assess_type, // Show Free-form or InBody Assessment
                    assessmentEditorContent: content,
                    totalBodyWater: total_body_water,
                    dryLeanMass: dry_lean_mass,
                    bodyFatMass: body_fat_mass,
                    pbf: pbf,
                    smm: smm,
                    bmi: bmi,
                    weight: weight,

                    rightArm:   right_arm,
                    leftArm:    left_arm,
                    trunk:      trunk,
                    rightLeg:   right_leg,
                    leftLeg:    left_leg,
                    isLoading: false
                });
                this.msgDataLoaded();
                this.getAttachment(assessment_id);
            } else {
                this.msgDataLoaded();

            }
    }

    async getAttachment (assessment_id) {

        var attachmentURL = await Storage.vault.get(assessment_id);
        if(assessment_id != undefined)
            this.setState({
                imageURL: attachmentURL
            })
    }

    cancelAssessment = () => {
        this.props.history.goBack();
    }

    handleMemberNameChange  = (client_id, client_name, email, dob, phone, phone_evening, emergency_contact_name, emergency_contact_phone_day, emergency_contact_phone_evening) => {

        this.setState({
            clientNameSearch: client_name,
            clientId: client_id,
            email: email,
            dob: dob,
            phone: phone,
            phone_evening: phone_evening,
            emergency_contact_name: emergency_contact_name,
            emergency_contact_phone_day: emergency_contact_phone_day,
            emergency_contact_phone_evening: emergency_contact_phone_evening
        });
    }

    handleTitleChange  = (event) => {
        var text = event.target.value;
        this.setState({
            title: text
        });
    }

    ////   SHOW THE ALERT MODAL   ////
    setModalAlertProps = (title_text, body_text, show_modal) => {
        var alert_object = {};
        var alert_action = "";

        this.setState({
            modalAlertTitleText: title_text,
            modalAlertBodyText:  body_text,
            showModalAlert:      show_modal, // true | false
            alertObject:         alert_object,
            alertAction:         alert_action
        })
    }

    checkIfMemberAndTitleTFExists = () => {
        var client_id          = this.state.clientId;
        var title              = this.state.title;
        console.log("Title: " + title);
        if(client_id === "undefined" || client_id === "&" || client_id === 0) { // client_id: 0 = "No Results"
            var body_text  = "A member name is required.";
            this.setModalAlertProps("Warning", body_text, true); // title_text, body_text, show_modal
            return false;
        } else if(title === "" || title == undefined) {
            var body_text  = "An assessment title is required.";
            this.setModalAlertProps("Warning", body_text, true); // title_text, body_text, show_modal
            return false;
        }

        return true;
    }

    addAssessmentToDB = async (assessment_type) => {
        var action;
        var client_id          = this.state.clientId;
        var company_id         = this.props.globalCompanyId;
        var title              = this.state.title;
        var assessment_id      = this.state.uid;

        if(assessment_id === "undefined") action = "new";

        var results = await invokeSetAddAssessment(action, client_id, company_id, title, emptyTemplate, assessment_id, assessment_type);
        return results;
    }

    handleSubmit = async event => {
        event.preventDefault();

        var action;
        var client_id          = this.state.clientId;
        var company_id         = this.props.globalCompanyId;
        var title              = this.state.title;
        var assessment_id      = this.state.uid;
        var assessment_type    = 1;
        var assessment_content = this.state.assessmentEditorContent;
        var content            = this.state.assessmentEditorContent;


        if(assessment_id === "undefined") action = "new";

        var exists = this.checkIfMemberAndTitleTFExists();
        if(!exists) return; // if there's no member name or title then you can't submit the form

        if(this.state.assessType == "inbody")
        {
                //var no_assessment_content = {};
                assessment_type  = 2;
                var total_body_water = this.state.totalBodyWater;
                var dry_lean_mass    = this.state.dryLeanMass;
                var body_fat_mass    = this.state.bodyFatMass;
                var pbf              = this.state.pbf;
                var smm              = this.state.smm;
                var bmi              = this.state.bmi;
                var weight           = this.state.weight;

                var rightArm         = this.state.rightArm;
                var leftArm          = this.state.leftArm;
                var trunk            = this.state.trunk;
                var rightLeg         = this.state.rightLeg;
                var leftLeg          = this.state.leftLeg;

                this.setState({ isLoading: true, showLoadingBar: "inline" });

                var results = await this.addAssessmentToDB(assessment_type);

                if(results.status === true) {
                    var assessment_id = results.assessment_id;

                    var results2 = await invokeSetAddInBodyAssessment(action, assessment_id, client_id, total_body_water, dry_lean_mass, body_fat_mass, pbf, smm, bmi, weight, rightArm, leftArm, trunk, rightLeg, leftLeg);

                    if(results2.status === true)
                        this.cancelAssessment();
                }
        } else if(this.state.assessType == "fms" || this.state.assessType == "heartandblood" || this.state.assessType == "spinalrom" || this.state.assessType == "lowerbodypower" ||
                  this.state.assessType == "strength" || this.state.assessType == "jointrom" || this.state.assessType == "bodycomp" || this.state.assessType == "girth" || this.state.assessType == "parq") {

        } else { //if(this.state.assessType != "inbody") {

                /////////////////////////////////////////////////////////////////
                /////////           BEGIN: FREE-FORM ASSESSMENT          ////////
                /////////////////////////////////////////////////////////////////
                //       STEP 1. TRACK IMAGES ADDED OR DELETED IN EDITOR       //
                // If content type is Object, skip "content" parse, otherwise if it's a string,
                // parse entityMap for image props and extract image id from AWS url

                if(typeof content === "string")
                    content = JSON.parse(content);

                let tmp_obj          = convertImageAttributes(content);
                let new_images_arr   = tmp_obj.tmp_img_src_arr;
                let tmp_img_data_arr = tmp_obj.tmp_img_data_arr;
                let existing_images_arr  = this.state.existingEditorImages;

                var compare = await compareExistingToNewImages(existing_images_arr, new_images_arr);

                if(compare) {
                        ///////////////////////////////////////////////////////////////////////
                        //    STEP 2. COMPARE EXISTING IMAGES TO NEW IMAGES WITHIN EDITOR    //
                        // Delete images that are no longer used!!!

                        /*if(client_id === "undefined" || client_id === "&" || client_id === 0) { // client_id: 0 = "No Results"
                            var body_text  = "A member name is required.";
                            this.setModalAlertProps("Warning", body_text, true); // title_text, body_text, show_modal
                            return;
                        } else if(title === "") {
                            var body_text  = "An assessment title is required.";
                            this.setModalAlertProps("Warning", body_text, true); // title_text, body_text, show_modal
                            return;
                        }*/

                        this.setState({ isLoading: true, showLoadingBar: "inline" });

                        try {

                            //const assessment_id = this.file ? await s3Upload(this.file) : null;
                            //var attachmentURL = await Storage.vault.get(assessment_id); //save attach url in db

                            ////  FREE-FORM
                            var results = await invokeSetAddAssessment(action, client_id, company_id, title, assessment_content, assessment_id, assessment_type);

                            if(results.status === true) {
                                this.cancelAssessment();
                            } else {
                                var body_text  = "Sorry, we had problems adding the assessment. Please try again";
                                this.setModalAlertProps("Warning", body_text, true); // title_text, body_text, show_modal
                                this.resetLoadingBar();
                            }
                        } catch (e) {
                            alert(e);
                            this.resetLoadingBar();
                        }
                        /* */
                }
        } // end type if
    }

    resetLoadingBar = () => {
        this.setState({ isLoading: false, showLoadingBar: "none" });
    }

    setExistingEditorImages = (content) => {
        this.setState({
            existingEditorImages: content
        });
    }

    assessmentEditorContent = (content) => {
        this.setState({
            assessmentEditorContent: content
        });
    }

    totalBodyWater = (text) => { this.setState({ totalBodyWater: text })}
    dryLeanMass    = (text) => { this.setState({ dryLeanMass: text }); }
    bodyFatMass    = (text) => { this.setState({ bodyFatMass: text }); }
    pbf            = (text) => { this.setState({ pbf: text}); }
    smm            = (text) => { this.setState({ smm: text}); }
    bmi            = (text) => { this.setState({ bmi: text}); }
    weight         = (text) => { this.setState({ weight: text}); }
    rightArm       = (text) => { this.setState({ rightArm: text}); }
    leftArm        = (text) => { this.setState({ leftArm: text}); }
    trunk          = (text) => { this.setState({ trunk: text}); }
    rightLeg       = (text) => { this.setState({ rightLeg: text}); }
    leftLeg        = (text) => { this.setState({ leftLeg: text}); }

    getAssessTitle (curr_assess_type) {
        var pre_title;

        if(curr_assess_type == "inbody")
            pre_title       = "InBody";
        else if (curr_assess_type == "heartandblood")
            pre_title       = "Heart & Blood Check";
        else if (curr_assess_type == "fms")
            pre_title       = "Functional Movement";
        else if (curr_assess_type == "lowerbodypower")
            pre_title       = "Lower Body Power";
        else if (curr_assess_type == "parq")
            pre_title       = "PAR-Q";
        else if (curr_assess_type == "primalmovement")
            pre_title       = "Primal Movement Patterns";
        else if (curr_assess_type == "strength")
            pre_title       = "Strength";
        else if (curr_assess_type == "jointrom")
            pre_title       = "Joint ROM";
        else if (curr_assess_type == "spinalrom")
            pre_title       = "Spinal ROM";
        else if (curr_assess_type == "bodycomp")
            pre_title       = "Body Composition";
        else if (curr_assess_type == "girth")
            pre_title       = "Girth Measurements";

        return pre_title;
    }

    renderHome() {
        var input_field;
        var assessment_id = this.state.uid;
        var client_id     = this.state.clientId;
        var textfield;
        var member_name = this.state.clientName;
        var raw_content = this.state.rawContent;
        var company_id  = this.props.globalCompanyId;
        var assess_type = this.state.assessType;
        var pre_title   = this.state.preTitle;

        if(pre_title == undefined) pre_title = this.getAssessTitle(assess_type)
        //console.log("++++++ assess_type: " + assess_type);

        if(member_name != "")
            textfield = <span   className="clientListRowMiddleLeft"
                                href= {"/client/detail/"+client_id}
                                style={{cursor:"pointer", color: Colors.default_blue, position:"relative", left:"-10px", fontSize:"24px"}}
                                onClick={(e) => handleGoToURL(e, this, "/client/detail/"+client_id)}>
                            <b className="pull-left">{ member_name }</b>
                        </span>
        else {
            textfield = <AutoSuggestClientName
                             handleMemberNameChange={this.handleMemberNameChange.bind(this)}
                             //defaultValue = {"f"}
                             client_name = {this.state.clientNameSearch}
                             company_id  = {company_id}
                         />
        }
        var title  = this.state.title;
        //Hide title otherwise the Title line will be too longer
        // if(title != "") title = ": " + title;

        var inbody_form;
        var assessment_editor;
        var form_body_comp;
        var form_fms;
        var form_girth_measurement;
        var form_heartandblood;
        var form_jointrom;
        var form_lowerbodypower;
        var form_parq;
        var form_primalmovement;
        var form_spinalrom;
        var form_strength;
        var intro_page_text;



        var form_buttons = <span>
                                <Row className="grid">
                                        <div className="iconAddExercise25pxVertSpacer"></div>
                                        <Col xs={6} sm={6} md={6}>
                                            <span onClick = { () => this.cancelAssessment()}>
                                                <LoaderButton
                                                  block
                                                  type    = "button"
                                                  text    = "Cancel"
                                                  style   = {{ fontSize:18, height:42, color:"black", backgroundColor: "#ccc"}}
                                                />
                                            </span>
                                        </Col>
                                        <Col xs={6} sm={6} md={6}>
                                                <LoaderButton
                                                  block
                                                  style   = {{ fontSize:18, height:42, color:"white", fontWeight: "bold", backgroundColor: Colors.ok_button_bg}}
                                                  //disabled={!this.validateForm()}
                                                  isLoading={this.state.isLoading}
                                                  text    = "Save"
                                                  type    = "submit"
                                                  loadingText="Saving …"
                                                />
                                        </Col>
                                </Row>
                          </span>
        if (assess_type === "bodycomp") {
              form_buttons = ""; // hide form buttons since they're insise the forms themselves
              form_body_comp = <BodyCompForm clientId          = {client_id}
                                             assessmentId      = {assessment_id}
                                             cancelAssessment  = {this.cancelAssessment}
                                             addAssessmentToDB = {this.addAssessmentToDB}
                                             checkIfMemberAndTitleTFExists = {this.checkIfMemberAndTitleTFExists}
                                             />
        } else if (assess_type === "girth") {
             form_buttons = ""; // hide form buttons since they're insise the forms themselves
             form_girth_measurement = <GirthForm clientId          = {client_id}
                                                 assessmentId      = {assessment_id}
                                                 cancelAssessment  = {this.cancelAssessment}
                                                 addAssessmentToDB = {this.addAssessmentToDB}
                                                 checkIfMemberAndTitleTFExists = {this.checkIfMemberAndTitleTFExists}
                                               />
        } else if(assess_type === "inbody") {

            inbody_form = <InBodyForm totalBodyWater = {this.totalBodyWater }
                                      dryLeanMass    = {this.dryLeanMass }
                                      bodyFatMass    = {this.bodyFatMass }
                                      pbf            = {this.pbf }
                                      smm            = {this.smm }
                                      bmi            = {this.bmi }
                                      weight         = {this.weight }
                                      rightArm       = {this.rightArm }
                                      leftArm        = {this.leftArm }
                                      trunk          = {this.trunk }
                                      rightLeg       = {this.rightLeg }
                                      leftLeg        = {this.leftLeg }
                                      totalBodyWater_val = {this.state.totalBodyWater}
                                      dryLeanMass_val    = {this.state.dryLeanMass}
                                      bodyFatMass_val    = {this.state.bodyFatMass}
                                      pbf_val            = {this.state.pbf}
                                      smm_val            = {this.state.smm}
                                      bmi_val            = {this.state.bmi}
                                      weight_val         = {this.state.weight}
                                      rightArm_val       = {this.state.rightArm}
                                      leftArm_val        = {this.state.leftArm}
                                      trunk_val          = {this.state.trunk}
                                      rightLeg_val       = {this.state.rightLeg}
                                      leftLeg_val        = {this.state.leftLeg}
                                      />
        } else if (assess_type === "fms") {
            form_buttons = ""; // hide form buttons since they're insise the forms themselves
            form_fms = <FMSForm clientId          = {client_id}
                                assessmentId      = {assessment_id}
                                cancelAssessment  = {this.cancelAssessment}
                                addAssessmentToDB = {this.addAssessmentToDB}
                                checkIfMemberAndTitleTFExists = {this.checkIfMemberAndTitleTFExists}
                              />
            intro_page_text = <Row className="grid" style={{textAlign: "left"}}>
                                        <Col xs={12} sm={12} md={12}>

                                              The FMS consists of 7 fundamental movement component tests that are scored on a scale of 0 - 3, with the sum creating a composite score ranging from 0 - 21 points.
                                              <ul>
                                                  <li>0 = the movement was not performed correctly in relation to the observable criteria</li>
                                                  <li>3 = the movement was performed correctly in relation to the observable criteria</li>
                                                  <li>High scores = the individual needs little to no corrections in their movements</li>
                                                  <li>Low scores = the individual needs more corrections in their movement</li>
                                              </ul>

                                              Raw Score: This score is used to denote right and left side scoring. The right and left sides are scored in five of the seven tests and both are documented in this space.
                                              <br/><br/>
                                              Final Score: This score is used to denote the overall score for the test. The lowest score for the raw score (each side) is carried over to give a final score for the test. A person who scores a three on the right and a two on the left would receive a final score of two. The final score is then summarized and used as a total score.
                                              <br/><br/>
                                              Clearing Test: A positive indicates pain. A negative indicates no pain. If pain is present (+), the score for that test would result in a 0.<br/>
                                              <br/><br/>
                                        </Col>
                                   </Row>
        } else if (assess_type === "heartandblood") {
              form_buttons = ""; // hide form buttons since they're insise the forms themselves
              form_heartandblood = <HeartAndBloodForm clientId          = {client_id}
                                                      assessmentId      = {assessment_id}
                                                      cancelAssessment  = {this.cancelAssessment}
                                                      addAssessmentToDB = {this.addAssessmentToDB}
                                                      checkIfMemberAndTitleTFExists = {this.checkIfMemberAndTitleTFExists}
                                                    />
        } else if(assess_type === "lowerbodypower") {
              form_buttons = ""; // hide form buttons since they're insise the forms themselves
              form_lowerbodypower = <LowerBodyPowerForm clientId          = {client_id}
                                                       assessmentId      = {assessment_id}
                                                       cancelAssessment  = {this.cancelAssessment}
                                                       addAssessmentToDB = {this.addAssessmentToDB}
                                                       checkIfMemberAndTitleTFExists = {this.checkIfMemberAndTitleTFExists}
                                                       />
        } else if(assess_type === "parq") {
             form_buttons = ""; // hide form buttons since they're insise the forms themselves
             form_parq = <PARQForm clientId                         = {client_id}
                                   assessmentId                     = {assessment_id}
                                   dob                              = {this.state.dob}
                                   email                            = {this.state.email}
                                   phone                            = {this.state.phone}
                                   phone_evening                    = {this.state.phone_evening}
                                   emergency_contact_name           = {this.state.emergency_contact_name}
                                   emergency_contact_phone_day      = {this.state.emergency_contact_phone_day}
                                   emergency_contact_phone_evening  = {this.state.emergency_contact_phone_evening}
                                   cancelAssessment                 = {this.cancelAssessment}
                                   addAssessmentToDB                = {this.addAssessmentToDB}
                                   checkIfMemberAndTitleTFExists    = {this.checkIfMemberAndTitleTFExists}
                                   />
        } else if(assess_type === "strength") {
             form_buttons = ""; // hide form buttons since they're insise the forms themselves
             form_strength      = <StrengthForm clientId          = {client_id}
                                                assessmentId      = {assessment_id}
                                                cancelAssessment  = {this.cancelAssessment}
                                                addAssessmentToDB = {this.addAssessmentToDB}
                                                checkIfMemberAndTitleTFExists = {this.checkIfMemberAndTitleTFExists}
                                                  />
        } else if(assess_type === "primalmovement") {
              form_buttons = ""; // hide form buttons since they're insise the forms themselves
              form_primalmovement= <PrimalMovement clientId          = {client_id}
                                                   assessmentId      = {assessment_id}
                                                   cancelAssessment  = {this.cancelAssessment}
                                                   addAssessmentToDB = {this.addAssessmentToDB}
                                                   checkIfMemberAndTitleTFExists = {this.checkIfMemberAndTitleTFExists}
                                                   />

        } else if(assess_type === "jointrom") {

               form_buttons = ""; // hide form buttons since they're insise the forms themselves
               form_jointrom = <JointROMForm clientId          = {client_id}
                                               assessmentId      = {assessment_id}
                                               cancelAssessment  = {this.cancelAssessment}
                                               addAssessmentToDB = {this.addAssessmentToDB}
                                               checkIfMemberAndTitleTFExists = {this.checkIfMemberAndTitleTFExists}
                                             />
        } else if(assess_type === "spinalrom") {

              form_buttons = ""; // hide form buttons since they're insise the forms themselves
              form_spinalrom = <SpinalROMForm clientId          = {client_id}
                                              assessmentId      = {assessment_id}
                                              cancelAssessment  = {this.cancelAssessment}
                                              addAssessmentToDB = {this.addAssessmentToDB}
                                              checkIfMemberAndTitleTFExists = {this.checkIfMemberAndTitleTFExists}
                                            />
              intro_page_text = <Row className="grid" style={{textAlign: "left"}}>
                                              <Col xs={12} sm={12} md={12}>
                                                Although various forms of goniometers and protractors are available to assess the ROM available in the spine, in actual practice gross observation of the ROM is typically used and the
                                                ​​grade is expressed as a percentage of the total possible normal ROM.
                                                ​​Similar to what occurs with the body's other joints, spinal ROM is graded quantitatively as well
                                                ​​as qualitatively, noting any pain produced during or at the end of the movement.
                                                <br/><br/>
                                              </Col>
                                     </Row>

        } else {
            assessment_editor = <div>
                                    <Row className="grid">
                                          <Col xs={12} sm={12} md={12}>
                                              <span className="formLabel">
                                                  Notes
                                              </span>
                                          </Col>
                                    </Row>
                                    <AssessmentEditor raw_content={this.state.assessmentEditorContent}
                                                      setExistingEditorImages={this.setExistingEditorImages}
                                                      assessmentEditorContent={this.assessmentEditorContent}/>
                                </div>


        }


        return (

          <div className="programs">
            <PageHeader>
                    {pre_title} Assessment{ /*title*/ }
                    <span style={{fontSize:"16px", color: "red"}}><br/>{ this.state.loadingData }</span>
            </PageHeader>
            <div>To submit an assessment, you must: <br/>1. Type in a member's name, select it from the the dropdown list and<br/>2. Add a title.</div>
            <br/>
            { /*<form onSubmit={this.handleSubmit} className="form">*/ }
            <form onSubmit={this.handleSubmit} className="form">

                { intro_page_text }
                <Row className="grid">
                      <Col xs={12} sm={12} md={12}>
                          <span className="formLabel">
                              Member Name
                          </span>
                      </Col>
                </Row>
                <Row className="grid">
                      <Col xs={12} sm={12} md={12}>
                          <span style={{fontSize:"20px", width:"100%"}} className="pull-left">
                              { textfield }
                          </span>
                      </Col>
                </Row>
                <div className="iconAddExercise25pxVertSpacer"></div>

                <Row className="grid">
                      <Col xs={12} sm={12} md={12}>
                          <span className="formLabel">
                              Title
                          </span>
                      </Col>
                </Row>
                <Row className="grid">
                      <Col xs={12} sm={12} md={12}>
                          <span>
                                <input type        = "text"
                                       style       = {{fontSize: 22}}
                                       value       = {this.state.title}
                                       onChange    = {this.handleTitleChange.bind(this)}
                                       className   = "input-lg tf_addExercise" />
                          </span>
                      </Col>
                </Row>
                <div className="iconAddExercise25pxVertSpacer"></div>
                { inbody_form }

                { assessment_editor }

                { form_buttons }

            </form>
            <span style={{paddingBottom: 20}}>

                { form_body_comp }
                { form_fms }
                { form_girth_measurement }
                { form_heartandblood }
                { form_jointrom }
                { form_lowerbodypower }
                { form_parq }
                { form_primalmovement }
                { form_spinalrom }
                { form_strength }
            </span>
            <br/><br/><br/>
            <br/><br/><br/>
          </div>
        );
    }

    render() {
        let closeModalAlert        = () => this.setState({ showModalAlert: false }); //close simple modal window

        return (
              <div className="Home">
                {this.props.isAuthenticated ? this.renderHome() : <RenderLander />}

                    <FooterLoadingBar text={"Saving New Assessment Data..."}
                                      showLoadingBar={this.state.showLoadingBar}/>

                      {this.state.showModalAlert ?
                          <ModalAlert
                              onHide         = {closeModalAlert}
                              alertFunction  = {this.alertFunction}     // custom function to call within modal
                              alertAction    = {this.state.alertAction} // flag used for above function
                              alertObject    = {this.state.alertObject} // vars used for above function
                              showModalAlert = {this.state.showModalAlert}
                              messageTitle   = {this.state.modalAlertTitleText}
                              messageBody    = {this.state.modalAlertBodyText}
                          />
                      : null}
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/assessment/AssessmentNew.js